import React from 'react';
import Sidebar from '../sidebar';
import OptionsContent from './OptionsContent';

export default function OptionsMonitor(): JSX.Element {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar variant='main' activeLink='options-monitor' />
      <OptionsContent />
    </div>
  );
}
